export const AUTH_REQUIRED_EVENT = 'psf-guard-auth-required';
